import React from 'react'
import { API_URL } from '../Constants'
import { SectionBase, DifficultyBadge, Time, NextQuestion } from './SectionBase'
import { Link } from 'react-router-dom'
import Menu from './Menu';
import Recorder from './Recorder';
import Writer from './Writer';
import Listening from './Listening';
export default class GenericTask extends SectionBase {

  TEST_TIMES = {'readthenwrite': 120}
  TEST_TITLES = {'readthenwrite': 'Write about the question in at least 50 words',
  'readthenspeak':'Speak about the question below',
  'listenthenspeak':'Listen to the question and speak your answer',
  'speakaboutphoto':'Describe the photo aloud',
  'writeaboutphoto':'Write one or more sentences that describe the photo'}
  MAX_LISTENS = 3;

  constructor(props) {
    super(props)
    this.getTaskTestTime = this.getTaskTestTime.bind(this)
    this.nextQuestion = this.nextQuestion.bind(this);
    this.onAnswerTextInput = this.onAnswerTextInput.bind(this)
    this.onDifficultyChange = this.onDifficultyChange.bind(this);
    this.onRecorderStop = this.onRecorderStop.bind(this);
    this.submit = this.submit.bind(this)
    this.onTimeIsUp = this.onTimeIsUp.bind(this);
    this.retry = this.retry.bind(this);
  }

  state = {
    difficulty: 1,
    answer_text: ''
  }

  getTaskTestTime(){
    return this.TEST_TIMES[this.props.appName] || 120;
  }

  async nextQuestion() {
    console.log('nextQ');

    const { difficulty } = this.state;
    const { token, appName } = this.props; //appName like readthenwrite

    const res = await fetch(`${API_URL}/${appName}/createquestion/${difficulty}`,
      { headers: { Authorization: `Token ${token}` } });
    try {
      const result = await res.json();
      let question = null;
      let question_id = null;
      let example_answer_file = null;
      let example_answer_text = null;

      
      question = result[0];
      question_id = question.id;
      console.log(question_id);
      ({example_answer_text,example_answer_file} = question);
    
      //TODO example_answer=

      const secondsLeft = this.getTaskTestTime();
      this.setState({ step:1,listensremaining:this.MAX_LISTENS, question, question_id,secondsLeft,example_answer_text,example_answer_file }, this.restartTimer);

    } catch (e) {
      console.log(e);
      console.log(res);
    }
  }
  
  onAnswerTextInput(e){
    this.setState({answer_text:e.target.value})
  }

  onTimeIsUp() {
    this.setState({ step: 2 })
  }

  onRecorderStop(data){
    const { audioObjectURL, audioBlobType } = data;
    this.setState({ step: 2, audioObjectURL, audioBlobType })
  }

  onDifficultyChange(e) {
    this.setState({ difficulty: e.target.value }, this.nextQuestion);

  }


  render() {
    const { token, appName } = this.props;

    const isRecording = appName === 'listenthenspeak' || appName ==='speakaboutphoto' || appName==='readthenspeak';
    const isWriting = appName === 'readthenwrite' || appName === 'writeaboutphoto';  
    let isSubmitAllowed = true;
    const { question, listensremaining,example_answer_text,example_answer_file,  answer_text, secondsLeft, step, profile, difficulty, audioObjectURL } = this.state;

    if (appName === 'readthenwrite' && answer_text.length<50) isSubmitAllowed = false;

    return (
      <>
        {token!==null && question && <div className={`${appName} ${appName}-step${step}`}>
          <Menu token={token}  profile={profile}onDifficultyChange={this.onDifficultyChange}></Menu>
          <Time seconds={secondsLeft}></Time>
          <DifficultyBadge difficulty={difficulty}></DifficultyBadge>
          <div className='px-5' >
            <h1 className='text-center'> {this.TEST_TITLES[appName]}</h1>
            <div className='my-5 text-center'>
              {question && question.text && <p className='fw-bold text-muted'>
                {question.text}
              </p>}
              {question && question.listening && <div>
              <Listening step={step} listensremaining={listensremaining} file={question.listening} onPlay={() => { this.setState({listensremaining:listensremaining-1}) }} />
              </div>}
              {question && question.photo && <div>
              <img className="rounded" src={question.photo} style={{maxWidth:'500px'}} alt='' />
              </div>}

            </div>


            {isRecording && <div className='text-center my-5'>
              <Recorder onStop={this.onRecorderStop} audioObjectURL={audioObjectURL} secondsLeft={secondsLeft}></Recorder>

            </div>}

            {isWriting && step ===1 && <div className='text-center my-5'>
              <Writer onInput={this.onAnswerTextInput}  answer={answer_text}/>
            </div>}

            {step >= 2 && <>
              {isRecording && <div className='result mb-2 text-center'>
                <p className='my-5'>
                You can compare your recorded answer with what the exam will expect below:

                </p>
                
                <div className='custom-box-1 shadow-lg text-center m-auto p-4 my-5' style={{maxWidth:'500px'}}>
                  <h4>Example Answer</h4>
                  <Listening file={example_answer_file} listensremaining={null} ></Listening>
                  
                  <p>{example_answer_text}</p>

                </div>

              </div>}
              {isWriting && <div className='result mb-2 text-center'>
                <p className='my-5'>
                You can compare your answer with the example answer below
                </p>
                <h4>Your Answer</h4>
                <textarea className='w-100' readOnly={true}>{answer_text}</textarea>
                <div className='custom-box-1 shadow-lg text-center m-auto p-4 my-5' style={{maxWidth:'500px'}}>
                  <h4>Example Answer</h4>
                  <p className='text-start'>
                  {example_answer_text}
                  </p>

                </div>

              </div>}

            </>
            }



            <div className='buttons d-flex justify-content-between'>
              <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.retry}>RETRY</button>
              {step === 1 && <button type="button" disabled={!isSubmitAllowed} className={`btn btn-dark rounded-pill`} onClick={this.submit}>SUBMIT</button>
              }
            </div>
            <NextQuestion nextQuestion={this.nextQuestion}></NextQuestion>
            {false && <div>{JSON.stringify(this.state)}</div>}
          </div>

        </div>}

        {token === null && <div className='p-5'>Please <Link to="/home/">login</Link> and refresh this page</div>}

      </>

    )
  }


  retry() {
    
    this.setState({ step: 1, listensremaining:this.MAX_LISTENS, secondsLeft: this.getTaskTestTime() , audioObjectURL:undefined, answer_text:'' });
    this.restartTimer();
  }

  async submit() {

    const {appName,token} = this.props;
    const { answer_text, question_id } = this.state;
    
    this.stopTimer();
    const res = await fetch(`${API_URL}/${appName}/submittedanswer`, {
      method: 'POST',
      body: JSON.stringify({ answer_text, question:question_id }),
      headers: { Authorization: `Token ${token}`, "Content-Type": "application/json" }
    });
    await res.json();
    this.setState({step:3});
    //TODO what if it fails. should relogin?
  }

  startRecording() {

  }

  



}
